/**
 * Gelly luxury pages — wishlist page, shared utilities
 */
(function () {
  var storageKey = 'gelly-wishlist';

  function readWishlist() {
    try {
      var list = JSON.parse(localStorage.getItem(storageKey) || '[]');
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function writeWishlist(list) {
    try {
      localStorage.setItem(storageKey, JSON.stringify(list));
    } catch (e) {}
    document.querySelectorAll('[data-gelly-wishlist-count]').forEach(function (el) {
      if (list.length) {
        el.textContent = String(list.length);
        el.removeAttribute('hidden');
      } else {
        el.setAttribute('hidden', '');
      }
    });
  }

  function formatMoney(cents) {
    if (window.theme && theme.Currency) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function buildWishlistCard(product) {
    var image = product.featured_image || (product.images && product.images[0]);
    var imageSrc = image ? image.replace(/(\.jpg|\.png|\.webp)(\?.*)?$/i, '_600x$1$2') : '';
    var price = product.price;
    var compare = product.compare_at_price;

    var priceHtml = formatMoney(price);
    if (compare && compare > price) {
      priceHtml = '<s>' + formatMoney(compare) + '</s> ' + priceHtml;
    }

    return (
      '<article class="gelly-wishlist-card" data-handle="' + product.handle + '">' +
        '<button type="button" class="gelly-wishlist-card__remove" data-gelly-wishlist-remove aria-label="Remove from wishlist">' +
          '<svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="2" d="M6 6l12 12M18 6L6 18"/></svg>' +
        '</button>' +
        '<a href="/products/' + product.handle + '" class="gelly-wishlist-card__link">' +
          '<div class="gelly-wishlist-card__media">' +
            (imageSrc ? '<img class="gelly-wishlist-card__image" src="' + imageSrc + '" alt="' + (product.title || '').replace(/"/g, '&quot;') + '" loading="lazy" width="600" height="600">' : '') +
          '</div>' +
          '<h3 class="gelly-wishlist-card__title">' + product.title + '</h3>' +
          '<p class="gelly-wishlist-card__price">' + priceHtml + '</p>' +
        '</a>' +
      '</article>'
    );
  }

  function initWishlistPage() {
    var page = document.querySelector('[data-gelly-wishlist-page]');
    if (!page) return;

    var grid = page.querySelector('[data-gelly-wishlist-grid]');
    var empty = page.querySelector('[data-gelly-wishlist-empty]');
    var loading = page.querySelector('[data-gelly-wishlist-loading]');
    var handles = readWishlist();

    if (!handles.length) {
      if (loading) loading.hidden = true;
      if (empty) empty.hidden = false;
      if (grid) grid.innerHTML = '';
      return;
    }

    Promise.all(
      handles.map(function (handle) {
        return fetch('/products/' + encodeURIComponent(handle) + '.js')
          .then(function (res) {
            if (!res.ok) throw new Error('not found');
            return res.json();
          })
          .catch(function () {
            return null;
          });
      })
    ).then(function (products) {
      var valid = products.filter(Boolean);
      var validHandles = valid.map(function (p) {
        return p.handle;
      });

      if (validHandles.length !== handles.length) {
        writeWishlist(validHandles);
      }

      if (loading) loading.hidden = true;

      if (!valid.length) {
        if (empty) empty.hidden = false;
        return;
      }

      if (empty) empty.hidden = true;
      if (grid) {
        grid.innerHTML = valid.map(buildWishlistCard).join('');
        grid.addEventListener('click', function (event) {
          var btn = event.target.closest('[data-gelly-wishlist-remove]');
          if (!btn) return;
          var card = btn.closest('[data-handle]');
          if (!card) return;
          var handle = card.getAttribute('data-handle');
          var list = readWishlist().filter(function (h) {
            return h !== handle;
          });
          writeWishlist(list);
          card.remove();
          if (!list.length) {
            if (empty) empty.hidden = false;
          }
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWishlistPage);
  } else {
    initWishlistPage();
  }
})();
